import { render, staticRenderFns } from "./OwnerNew.vue?vue&type=template&id=51d5c09e&"
import script from "./OwnerNew.vue?vue&type=script&lang=js&"
export * from "./OwnerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports